export enum SkillStatus {
  Completed,
  InCompleted,
  OverCompleted
}
